import React, { useState, useRef } from 'react'
import ReactMarkdown from 'react-markdown'

import { Button } from '../../common/components/button'
import { Modal } from '../../common/components/modal'
import { blockViewComponents } from './block-view-components'
import { PlaceholderBlock } from './placeholder/placeholder-block'
import { BlockErrorBoundary } from './block-error-boundary'
import { useReportPageContext } from '../contexts/report-page.context'

import { useStyles } from './report-block.style'
import { REPORT_VIEWERS } from '../constants'

function EmptyBlock () {
  return null
}

export const ReportBlock = function ({
  blockKey,
  dataKey,
  type,
  title,
  isSplit,
  description,
  props = [],
  dataFiles = [],
  report,
  caption,
  methods,
  onCommentClick = () => {},
  isPreviewMode = false,
  width,
  height,
  style = {},
  ...additionalProps
}) {
  const ref = useRef()
  const { page } = useReportPageContext()
  const classes = useStyles({ width, viewer: page && page.viewer })
  const [ isModalOpen, setIsModalOpen ] = useState(false)

  const blockProps = Array.isArray(props)
    ? props.reduce((blockProps, { key, value, dataFileKey }) => {
      // TODO: we can remove this when we have all blocks retrieving their own data
      if (dataFileKey) {
        value = getDataFileValue(dataFileKey)
      }
      return Object.assign(blockProps, { [key]: value })
    }, {})
    : props || {}

  const Block = props.placeholder ? PlaceholderBlock : (blockViewComponents[type] || EmptyBlock)

  // Support pulling description from a markdown file
  if (description && description.dataFileKey) {
    description = getDataFileValue(description.dataFileKey)
  }

  // Support pulling methods modal content from a markdown file
  if (methods && methods.dataFileKey) {
    methods.markdown = getDataFileValue(methods.dataFileKey)
  }

  function getDataFileValue (dataFileKey) {
    const dataFile = dataFiles.find((f) => f.key === dataFileKey) || {}
    return dataFile ? dataFile.value : undefined
  }

  function handleMethodsClick () {
    setIsModalOpen(true)
  }

  function handleModalClose () {
    setIsModalOpen(false)
  }

  function handleViewAllMethods () {
    const { reportId, reportBlock } = methods.detailLink
    window.open(`/reports/${reportId}/view#${reportBlock}`)
  }

  return (
    <BlockErrorBoundary>
      <div className={`${classes.container} ${isPreviewMode ? classes.previewMode : ''}`} ref={ref}>
        { title && <h3 data-qa="block-title" className={classes.title}>{title}</h3> }
        { page.viewer !== REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE && description && <div className={classes.description}><ReactMarkdown>{description}</ReactMarkdown></div> }
        <Block style={style} blockKey={blockKey} dataKey={dataKey} blockType={type} report={report} isPreviewMode={isPreviewMode} width={width} height={height} {...blockProps} {...additionalProps} />
        { (caption || methods) &&
          <div className={classes.caption}>
            <div className={classes.captionText}>
              {caption} { methods && (
                <Button variant="inline-link" onClick={handleMethodsClick}>
                  See more detail about the methods used.
                </Button>
              ) }
            </div>
            { methods &&
              <Modal isOpen={isModalOpen} onClose={handleModalClose} title={methods.title}
                footer={<div>
                  {methods.detailLink && <Button variant="link" onClick={handleViewAllMethods}>View All Methods</Button>}
                  <Button variant="secondary" onClick={handleModalClose}>Close</Button>
                </div>}>
                <ReactMarkdown>{methods.markdown}</ReactMarkdown>
              </Modal>
            }
          </div>
        }
      </div>
    </BlockErrorBoundary>
  )
}
